var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"11.5","fill":"white","stroke":"#0E9BC0"}}),_c('rect',{attrs:{"x":"6","y":"11.5","width":"12","height":"1","fill":"#0E9BC0"}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }